/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaryTypes } from 'app/entities/clinical-dictionary-type/clinical-dictionary-type.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { createEntity, getEntity, reset, updateEntity } from './clinical-dictionary.reducer';

export const ClinicalDictionaryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaryTypes = useAppSelector(state => state.clinicalDictionaryType.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const clinicalDictionaryEntity = useAppSelector(state => state.clinicalDictionary.entity);
  const loading = useAppSelector(state => state.clinicalDictionary.loading);
  const updating = useAppSelector(state => state.clinicalDictionary.updating);
  const updateSuccess = useAppSelector(state => state.clinicalDictionary.updateSuccess);

  const handleClose = () => {
    navigate(`/clinical-dictionary${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaryTypes({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.createDate !== undefined && typeof values.createDate !== 'number') {
      values.createDate = Number(values.createDate);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...clinicalDictionaryEntity,
      ...values,
      dictionaryType: clinicalDictionaryTypes.find(it => it.id.toString() === values.dictionaryType?.toString()),
      parent: clinicalDictionaries.find(it => it.id.toString() === values.parent?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...clinicalDictionaryEntity,
          dictionaryType: clinicalDictionaryEntity?.dictionaryType?.id,
          parent: clinicalDictionaryEntity?.parent?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.clinicalDictionary.home.createOrEditLabel" data-cy="ClinicalDictionaryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.clinicalDictionary.home.createOrEditLabel">
              Create or edit a ClinicalDictionary
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="clinical-dictionary-id"
                  label={translate('tinyMedicRestApp.clinicalDictionary.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionary.entityid')}
                id="clinical-dictionary-entityid"
                name="entityid"
                data-cy="entityid"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionary.entityType')}
                id="clinical-dictionary-entityType"
                name="entityType"
                data-cy="entityType"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionary.name')}
                id="clinical-dictionary-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionary.value')}
                id="clinical-dictionary-value"
                name="value"
                data-cy="value"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionary.createdBy')}
                id="clinical-dictionary-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionary.createDate')}
                id="clinical-dictionary-createDate"
                name="createDate"
                data-cy="createDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionary.lastUpdated')}
                id="clinical-dictionary-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionary.lastModifiedBy')}
                id="clinical-dictionary-lastModifiedBy"
                name="lastModifiedBy"
                data-cy="lastModifiedBy"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionary.active')}
                id="clinical-dictionary-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionary.cursor')}
                id="clinical-dictionary-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionary.microSec')}
                id="clinical-dictionary-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionary.timestampEntry')}
                id="clinical-dictionary-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="clinical-dictionary-dictionaryType"
                name="dictionaryType"
                data-cy="dictionaryType"
                label={translate('tinyMedicRestApp.clinicalDictionary.dictionaryType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaryTypes
                  ? clinicalDictionaryTypes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="clinical-dictionary-parent"
                name="parent"
                data-cy="parent"
                label={translate('tinyMedicRestApp.clinicalDictionary.parent')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/clinical-dictionary" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ClinicalDictionaryUpdate;
